import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Getgerencia, uploadIdVendedores } from '../../data';
import editIco from '../../assets/images/editIco.png';
import searchIco from '../../assets/images/searchIco.png';

export const GroupGeren = () => {
    const downloading = useSelector((state) => state.downloadElements);
    const userList = useSelector((state) => state.userList);
    const clients = useSelector(state => state.clients);
    const vendedores = useSelector((state) => state.vendedores);
    const [geren, setGeren] = useState([]);
    const [clientsFiltrados, setClientsFiltrados] = useState([]);
    const [userSeleccionado, setUserSeleccionado] = useState([]);
    const [gerenteSeleccionados, setGerenteSeleccionados] = useState([]);
    const [forUpload, setForUpload] = useState("");
    const [nombreCompleto, setNombreCompleto] = useState([]);
    const [aCheckear, setACheckear] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [editModeMap, setEditModeMap] = useState({});
    const [finalUser, setFinalUser] = useState({
        IdVendedor: '',
        Clientes: [],
        IdName: '',
        Permiso: ''
    });
    const [selectedID, setSelectedID] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const buildUserKey = (user) => `${user.Nombre}_${user.Apellido}`;

    const normalizeText = (value) => {
        if (!value) return '';
        return value
            .toString()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    };

    useEffect(() => {
        const fetchData = async () => {
            const gerencia = await Getgerencia();
            setGeren(gerencia);
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (!selectedID && geren.length > 0) {
            setSelectedID(geren[0].Id);
        }
    }, [geren, selectedID]);

    useEffect(() => {
        createIdZona(finalUser);
    }, [finalUser]);

    const handleIDZChange = (event) => {
        setSelectedID(event.target.value);
    };

    useEffect(() => {
        if (!selectedID) return;

        const selectedIdNumber = parseInt(selectedID, 10);
        const filteredUsers = clients.filter(cliente => cliente.ID_Dpto_Ventas === selectedIdNumber);
        setClientsFiltrados(filteredUsers);

        const selectedGerentes = geren.filter(gerente => parseInt(gerente.Id, 10) === selectedIdNumber);
        setGerenteSeleccionados(selectedGerentes);

        setEditMode(false);
        setSearchTerm('')
    }, [selectedID, clients, geren]);

    useEffect(() => {
        const vendedor = gerenteSeleccionados.map(gerente => gerente.Vendedor);
        const filteredUserList2 = userList.filter(user => user.PID === vendedor[0]);
        const combinedUserList = [...filteredUserList2];
        fetchClients(combinedUserList);
        setSearchTerm('')
    }, [gerenteSeleccionados]);

    const fetchClients = (combinedUserList) => {
        const filteredAndMappedUserList = combinedUserList.filter(user => user.Apellido !== 'Chiachio');
        const nombresCompletos = combinedUserList.map(user => buildUserKey(user));
        setNombreCompleto(nombresCompletos);
        setUserSeleccionado(filteredAndMappedUserList);
        const initialEditModeMap = {};
        filteredAndMappedUserList.forEach(user => {
            initialEditModeMap[buildUserKey(user)] = false;
        });
        setEditModeMap(initialEditModeMap);
    };

    useEffect(() => {

        const nombres = userSeleccionado.map(user => buildUserKey(user));
        const usuariosEncontrados = {};
        nombres.forEach(nombre => {
            const encontrarNombre = vendedores.find(vendedor => vendedor.IdName === nombre);

            if (encontrarNombre) {
                usuariosEncontrados[nombre] = encontrarNombre.Clientes || [];
            } else {
                usuariosEncontrados[nombre] = [];
            }
        });
        setACheckear(usuariosEncontrados);
    }, [userSeleccionado]);

// habilita la edicion cuando EditMode esta en true, y tambien busca los clientes previos
    const godMode = (user) => {
        const userKey = buildUserKey(user);
        setEditModeMap({ [userKey]: true });
        setEditMode(true);
        const assignedClients = aCheckear[userKey] || [];

        setFinalUser({
            IdVendedor: user.PID,
            Clientes: [...assignedClients],
            IdName: userKey,
            Permiso: user.Permiso,
        });
    };

    const addClientsToSelection = (cuits) => {
        setFinalUser(prevState => {
            const next = new Set(prevState.Clientes || []);
            cuits.forEach((cuit) => next.add(cuit));
            return {
                ...prevState,
                Clientes: Array.from(next),
            };
        });
    };

    const removeClientsFromSelection = (cuits) => {
        const removeSet = new Set(cuits);
        setFinalUser(prevState => ({
            ...prevState,
            Clientes: (prevState.Clientes || []).filter(cliente => !removeSet.has(cliente)),
        }));
    };

    const clearSelection = () => {
        setFinalUser(prevState => ({
            ...prevState,
            Clientes: [],
        }));
    };

    const functionPruv = (cuit, pid, isChecked, Nombre, Apellido, Permiso) => {
        if (isChecked) {
            setFinalUser(prevState => {
                const next = new Set(prevState.Clientes || []);
                next.add(cuit);
                return {
                    ...prevState,
                    IdVendedor: pid,
                    IdName: `${Nombre}_${Apellido}`,
                    Clientes: Array.from(next),
                    Permiso: Permiso
                };
            });
        } else {
            removeClientsFromSelection([cuit]);
        }
    };

// creacion del idzona, para el objeto en firebase
    const createIdZona = (ver) => {
        const gerenEncontrada = geren.filter(geren => geren[ver.Permiso] == ver.IdVendedor);
        const ids = gerenEncontrada.map(geren => geren.Id);
        const IdZona = ids.join(', ');
        const verConIdZonas = { ...ver, IdZona };

        setForUpload(verConIdZonas);
    };

    const isLoading = Object.values(downloading).includes(false);

    //Le mandamos el documento a la funcion de firebase
    const handleForSubmit = () => {
        uploadIdVendedores(forUpload);
        setTimeout(() => {
            window.alert("La subida se ha completado correctamente.");
            window.location.reload();
        }, 3000);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    //filtro de clientes 
    const normalizedSearch = normalizeText(searchTerm.trim());
    const filteredClients = clientsFiltrados.filter(cliente => {
        if (!normalizedSearch) return true;
        const fields = [cliente.Cliente, cliente.CUIT, cliente.Cliente_ID];
        return fields.some(field => normalizeText(field).includes(normalizedSearch));
    });
    const filteredClientIds = filteredClients
        .map(cliente => cliente.CUIT)
        .filter(Boolean);
    const allClientIds = clientsFiltrados
        .map(cliente => cliente.CUIT)
        .filter(Boolean);
    const activeUserLabel = finalUser.IdName ? finalUser.IdName.replace('_', ' ') : '';
    // console.log(forUpload)
    // console.log(clientsFiltrados)
    return (
        <>
            {isLoading ? (
                <div className='d-flex justify-content-center' style={{ margin: '15rem' }}>
                    <div style={{ background: "#4b4949", borderRadius: "15px", width: "15rem", height: "18rem" }}>
                        <div className='d-flex justify-content-center'>
                            <span className="loaderIndi2"></span>
                        </div>
                        <div className="load-wrapp" style={{ width: '100%' }}>
                            <div className="load-3">
                                <div className="line">c</div>
                                <div className="line">a</div>
                                <div className="line">r</div>
                                <div className="line">g</div>
                                <div className="line">a</div>
                                <div className="line">n</div>
                                <div className="line">d</div>
                                <div className="line">o</div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="assignPanel">
                    <div className="assignToolbar">
                        <div className="d-flex align-items-center gap-2">
                            <span>Seleccionar zona:</span>
                            <select
                                className="form-control inputs"
                                value={selectedID}
                                onChange={handleIDZChange}
                            >
                                {!selectedID && <option value="">Seleccionar zona</option>}
                                {geren
                                    .sort((a, b) => {
                                        const numA = parseInt(a.AreaDeVentas.split(' ')[0]);
                                        const numB = parseInt(b.AreaDeVentas.split(' ')[0]);
                                        return numA - numB;
                                    })
                                    .map((geren, index) => (
                                        <option key={index} value={geren.Id}>
                                            {geren.AreaDeVentas}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="adminSearch">
                            <img src={searchIco} alt="Buscar" className="adminSearchIcon" />
                            <input
                                className="form-control inputs adminSearchInput"
                                type="text"
                                placeholder="Buscar cliente por nombre o CUIT"
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                        </div>

                        <div className="assignMeta">
                            {filteredClients.length} de {clientsFiltrados.length} clientes
                        </div>

                        {editMode && (
                            <div className="assignActions">
                                <span className="assignActiveUser">Editando: {activeUserLabel}</span>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => addClientsToSelection(allClientIds)}
                                    disabled={allClientIds.length === 0}
                                >
                                    Seleccionar todos
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => addClientsToSelection(filteredClientIds)}
                                    disabled={filteredClientIds.length === 0}
                                >
                                    Agregar filtrados
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => removeClientsFromSelection(filteredClientIds)}
                                    disabled={filteredClientIds.length === 0}
                                >
                                    Quitar filtrados
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={clearSelection}
                                    disabled={finalUser.Clientes.length === 0}
                                >
                                    Limpiar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={handleForSubmit}
                                    disabled={!finalUser.IdName}
                                >
                                    Guardar
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="assignTableWrapper">
                        <table className="assignTable">
                            <thead>
                                <tr>
                                    <th className="clientCell">Nombre cliente</th>
                                    {userSeleccionado.map((user) => {
                                        const userKey = buildUserKey(user);
                                        const isEditable = editModeMap[userKey];
                                        const assignedCount = (aCheckear[userKey] || []).length;
                                        return (
                                            <th key={userKey} className={isEditable ? 'assignColActive' : ''}>
                                                <div className="assignUserHeader">
                                                    <div className="assignUserTitle">
                                                        {user.Nombre} {user.Apellido}
                                                    </div>
                                                    <div className="assignUserMeta">{assignedCount} clientes</div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary assignEditButton"
                                                        onClick={() => godMode(user)}
                                                    >
                                                        <img src={editIco} alt="Edit Icon" />
                                                    </button>
                                                </div>
                                            </th>
                                        );
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredClients.map((cliente) => (
                                    <tr
                                        key={cliente.CUIT || cliente.Cliente_ID || cliente.Cliente}
                                        className="assignRow"
                                    >
                                        <td className="clientCell">{cliente.Cliente}</td>
                                        {userSeleccionado.map((user) => {
                                            const userKey = buildUserKey(user);
                                            const isEditable = editModeMap[userKey];
                                            const assigned = aCheckear[userKey] && aCheckear[userKey].includes(cliente.CUIT);
                                            const checked = isEditable
                                                ? (finalUser.Clientes || []).includes(cliente.CUIT)
                                                : Boolean(assigned);
                                            const checkboxClass = [
                                                'assignCheckbox',
                                                isEditable ? 'assignCheckbox--editable' : 'assignCheckbox--readonly',
                                                checked ? 'assignCheckbox--checked' : '',
                                            ].join(' ');
                                            return (
                                                <td
                                                    key={`${userKey}-${cliente.CUIT || cliente.Cliente_ID}`}
                                                    className={isEditable ? 'assignColActive' : ''}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className={checkboxClass}
                                                        checked={checked}
                                                        onChange={(event) => {
                                                            if (!isEditable) return;
                                                            functionPruv(
                                                                cliente.CUIT,
                                                                user.PID,
                                                                event.target.checked,
                                                                user.Nombre,
                                                                user.Apellido,
                                                                user.Permiso
                                                            );
                                                        }}
                                                        disabled={!isEditable}
                                                    />
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
};
